import { toISODate } from './date';
import { openPresentationWindow } from './openPresentationWindow';

/** 메인 앱에서 메인 프레젠테이션 새 탭 URL을 만든다. */
export function buildMainPresentationTabUrl(opts: {
  workspaceId: string;
  gradeId?: string;
  date?: Date;
  /** 열자마자 시작할 튜토리얼 id (예: main-presentation) */
  tutorialId?: string;
  tutorialStep?: number;
}): string {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  const params = new URLSearchParams({ ws: opts.workspaceId.trim() });
  const gradeId = (opts.gradeId ?? '').trim();
  if (gradeId) params.set('grade', gradeId);
  params.set('date', toISODate(opts.date ?? new Date()));
  if (opts.tutorialId) {
    params.set('tutorial', opts.tutorialId);
    if (typeof opts.tutorialStep === 'number' && Number.isFinite(opts.tutorialStep)) {
      params.set('tutorialStep', String(Math.max(0, Math.floor(opts.tutorialStep))));
    }
  }
  return `${base}/dashboard-presentation?${params.toString()}`;
}

/**
 * 메인 프레젠테이션을 새 탭으로 연다. (듀얼 모니터 + 창 관리 권한 허용 시 다른 화면에 창으로)
 * `noopener` feature를 쓰면 성공해도 Window가 null이라 팝업 차단과 구분할 수 없어,
 * 연 뒤 `opener`만 끊는다.
 */
export function openMainPresentationTab(opts: {
  workspaceId: string;
  gradeId?: string;
  date?: Date;
  tutorialId?: string;
  tutorialStep?: number;
}): Window | null {
  if (!opts.workspaceId.trim()) return null;
  const url = buildMainPresentationTabUrl(opts);
  return openPresentationWindow(url);
}
